import {
  CompanyConfigDocument,
  DeleteAuthenticationDomainDocument,
} from 'generated/resources/graphql'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useMutation } from 'modules/core/hooks/useMutation'

export function useDeleteAuthenticationDomain() {
  const [mutation, { loading }] = useMutation(DeleteAuthenticationDomainDocument, {
    extractorFn: (data) => data.authenticationMutations.deleteAuthenticationDomain,
  })

  const deleteAuthenticationDomain = useUnsafeCallback(
    (id: string) => {
      return mutation({
        variables: {
          id: id,
        },
        refetchQueries: [CompanyConfigDocument],
      })
    },
    [mutation]
  )

  return {
    deleteAuthenticationDomain,
    loading,
  }
}
